import React, { useImperativeHandle, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { cx } from 'core/api';
import { useI18n } from 'i18n';
import { actions } from 'core/redux/api/reports';
import Form from 'core/react/general/form/Form';
import { localStorage as storage } from 'core/app/storage';
import DummyControl from 'core/react/general/form/DummyControl';
import GroupingPicker from 'core/react/share/categories/GroupingPicker';

/**
 * @param {Object} props
 * @param {React.RefObject} props.customRef
 * @param {Object} props.timeRange
 * @param {boolean} [props.disabled]
 */

function DeviceUsages(props) {
	const { f } = useI18n();
	const dispatch = useDispatch();

	const [isAssetTypes, setIsAssetTypes] = useState(false);
	const [isGrouping, setGrouping] = useState(false);
	const [groupingId, setGroupingId] = useState(storage.get('groupingId'));

	useImperativeHandle(props.customRef, () => ({
		submit: () => {
			const parameters = new cx.ods.reports.DeviceUsageReportParameters();
			parameters.timeRange = props.timeRange;
			parameters.groupingId = isGrouping ? groupingId : null;
			parameters.isAssetTypes = isAssetTypes;
			dispatch(actions.deviceUsages.request({ parameters, clear: true }));
		},
		clear: () => {
			dispatch(actions.deviceUsages.exportClear());
		},
	}));

	return (
		<>
			<Form.ControlGroup>
				<Form.Control
					controlType={Form.Control.Type.Checkbox}
					controlName="isGrouping"
					value={isGrouping}
					onChange={setGrouping}
					label={f('include device grouping')}
				/>
				<Form.Control controlType={DummyControl} controlName="grouping" value={groupingId} onChange={() => {}} hidden />
				<GroupingPicker
					disabled={!isGrouping}
					categoryId={groupingId}
					onChange={setGroupingId}
					cleanable={false}
				/>
				<Form.Control
					controlType={Form.Control.Type.Checkbox}
					controlName="isAssetTypes"
					value={isAssetTypes}
					onChange={setIsAssetTypes}
					label={f('include asset types')}
					disabled={props.disabled}
				/>
			</Form.ControlGroup>
		</>
	);
}

export default connect((state) => {
	return {
		state: state.reports.deviceUsages,
	};
})(DeviceUsages);
